import { Poppins} from 'next/font/google';
import React, { useEffect, useState } from 'react';
import EnrollForm from './enroll-form';

const popins = Poppins({
  weight: ['400', '500', '600', '700'],
  subsets: ['latin'],
  display: 'swap',
  preload: true,
});


export default function CourseTabs({ refs,title,location1}) {
  const [activeTab, setActiveTab] = useState('Overview'); // Default active tab is set to "Overview"
  const [formPopup,setFormPopup] = useState(false);
  const scrollToSection = (ref, tabName) => {
    setActiveTab(tabName); // Update activeTab when clicked
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
const handlePopup = () =>{
    setFormPopup(true);
}

const handleCloseForm = ()=>{
    setFormPopup(false)
 }


  const tabs = [
    { label: 'Overview', ref: refs.overViewRef },
    { label: 'Training', ref: refs.trainingModeRef },
    { label: 'Curriculam', ref: refs.courseSyllabus },
    { label: 'Projects', ref: refs.projectRef },
    { label: 'Certifications', ref: refs.courseCertificate },
    { label: 'Reviews', ref: refs.testimonialRef },
    { label: 'Job Supports', ref: refs.jobSupportRef },
    { label: 'FAQ', ref: refs.courseFaq },
  ];
  useEffect(() => {
    const handleScroll = () => {
      tabs.forEach((tab) => {
        const ref = tab.ref.current;
        if (ref) {
          const rect = ref.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveTab(tab.label); // Update active tab
          }
        }
      });
    };
  
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [tabs]);
  
  return (
    <>
      <section className={`tabs-box mdn`}>
        <div className={`container`}>
          <div className="fw df fjsb mfji gap10">
            {tabs.map((tab) => (
              <p
                key={tab.label}
                onClick={() => scrollToSection(tab.ref, tab.label)}
                className={`fs-16 mfs-15 fwb500 cursor ${popins.className} ${
                  activeTab === tab.label ? 'active' : ''
                }`}
              >
                {tab.label}
              </p>
            ))}
            <button onClick={handlePopup} className={`tab-enroll cw fs-16 mfs-15 fwb600 ${popins.className}`}>
              Enroll Now
            </button>
        
        </div>
          </div>
         
      </section>
      {formPopup && 
    (  
     <><div className="backdrop"></div><div className="popup">
                  <EnrollForm course={`${title}`} classType={true} message={true}  closeForm={handleCloseForm} closeBtn={true}/>
              </div></>)}
      <style jsx>{`

              p {
          padding: 10px 15px;
          position: relative;
        }

        p.active {
          color: #FFA900; /* Highlight active tab */
          font-weight: bold;
        }
 
          p::before {
            content: '';
            position: absolute;
            bottom: 0px;
             left: 50%; /* Start from the center */
             transform: translateX(-50%) scaleX(0); /* Center and scale for animation */
             width: 100%; /* Full width when active */
            height: 3px;
            background-color: #ffbd50;
            transition: all 0.5s;
            transform-origin: center; /* Ensures animation starts from the center */
          }
 
          p:hover{
          color: #ffbd50;  
          transition: all 0.5s;
          }
 
          p.active::before {
    transform: translateX(-50%) scaleX(1); /* Scale fully when active */
  }
 
          .active {
            color: #ffbd50;
          }

      `}</style>
    </>
  );
}
